import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
import axios from '@/common/axios'


const LOGOUT_USER = 'LOGOUT_USER'

//console.log('createLedger: '+ ADD_CARTRULES)

const lottoresult_obj = {
    namespaced: true,
    state: {
        lottoresult: []
    },
    mutations: {
        LOGOUT_USER (state) {
            state.lottoresult = []
        }
    },
    getters: {
        lottoresult (state) {
            return state.lottoresult
        }
    },
    actions: {
        // API Calls
        async getAllRoudGov ({ dispatch, commit, getters, rootGetters }) {
            try {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootGetters['user/accessToken']
                const response = await axios.get('allroundgove')
                //commit(ADD_CARTRULES, response.data)
                console.log('getAllRoudGov: ', response)
                return response.data
            } catch (error) {
                throw new Error(error)
            }
        },

        async getLottoResult ({ dispatch, commit, getters, rootGetters }, data) {
            try {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootGetters['user/accessToken']
                const response = await axios.get('lottoresult', {params: {lottotype_id: data.lottotype_id, round_id: data.round_id, date_result: data.date_result}})
                return response.data
            } catch (error) {
                throw new Error(error)
            }
        },

        async getLottoResultByDate ({ dispatch, commit, getters, rootGetters }, data) {
            try {
                //console.log('getLottoResultByDate data: ', data)
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootGetters['user/accessToken']
                const response = await axios.get('lottoresultbydate/' + data)
                //console.log('getLottoResultByDate response: ', response.data)
                return response.data
            } catch (error) {
                throw new Error(error)
            }
        },

        async getCurrentLottoResult ({ dispatch, commit, getters, rootGetters }, data) {
            try {
                //console.log('getLottoResultByDate data: ', data)
                //axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootGetters['user/accessToken']
                const response = await axios.get('currentlottoresult/' + data)
                //console.log('getLottoResultByDate response: ', response.data)
                return response.data
            } catch (error) {
                throw new Error(error)
            }
        },

        async getLottoResultByType ({ dispatch, commit, getters, rootGetters }, data) {
            try {
                //console.log('getLottoResultByType data: ', data)
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootGetters['user/accessToken']
                const response = await axios.get('lottoresultbytype/' + data.lottotype_id + '/' + data.round_id, {params: {order: data.order, limit: data.limit}})
                //console.log('getLottoResultByType: ', response.data)
                return response.data
            } catch (error) {
                throw new Error(error)
            }
        },

        async getGovLottoResult ({ dispatch, commit, getters, rootGetters }, data) {
            try {
                //console.log('getGovLottoResult data: ', data)
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootGetters['user/accessToken']
                const response = await axios.get('govlottoresult', {params: {order: data.order, limit: data.limit}})
                //console.log('getGovLottoResult: ', response.data)
                return response.data
            } catch (error) {
                throw new Error(error)
            }
        },

        // Only Mutations
        async userLogout ({ dispatch, commit, getters, rootGetters }) {
            try {
                commit(LOGOUT_USER)
            } catch (error) {
                throw new Error(error)
            }
        },
    }
}

export default lottoresult_obj
